import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-acd-contact-setting-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAcdContactSettingIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfAcdContactSettingIcon(props: CcfAcdContactSettingIconProps) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <path
        d="M18 0H2C0.9 0 0 0.9 0 2V15C0 16.1 0.9 17 2 17H18C19.1 17 20 16.1 20 15V2C20 0.9 19.1 0 18 0ZM18 15H2V2H18V15Z"
        fill="#FF9400"
      />
      <path
        d="M9.4 11.4C9.1 11 8.6 10.7 8.1 10.4L7.3 10.1L8 9.6C8.2 9.4 8.4 9.2 8.5 9C8.7 8.6 8.8 8.2 8.8 7.8C8.8 7.2 8.6 6.6 8.2 6.2C8 6 7.9 5.9 7.8 5.8C7 5.3 5.8 5.4 5.1 6.1C4.7 6.6 4.4 7.1 4.5 7.7C4.5 8.1 4.6 8.6 4.8 9C4.9 9.2 5.1 9.4 5.3 9.6L6 10.1L5.2 10.4C4.7 10.6 4.2 11 3.9 11.4C3.5 11.9 3.2 13 3.2 13H10.1C10.1 13 9.8 11.9 9.4 11.4Z"
        fill="#FF9400"
      />
      <path d="M10 5H17V7H10V5Z" fill="#FF9400" />
      <path d="M11 8H17V10H11V8Z" fill="#FF9400" />
      <path d="M12 11H17V13H12V11Z" fill="#FF9400" />
    </SvgIcon>
  );
}

export default CcfAcdContactSettingIcon;
